
webpack.register(
    'modules/exemptions/exemptions-by-category/exemptions-by-category',
    function() {
        return import('modules/exemptions/exemptions-by-category/exemptions-by-category');
    },
    true
);